export {useRichTextKey} from 'mkt-ssr/lib/intl/useRichTextKey';
